<template>
	<div class="container">
		<div class="swiper-container banner" v-if="bannerList.length>0">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="item in bannerList" :key="item.id">
					<img :src="item.picUrl"/>
				</div>
			</div>
			<div class="swiper-pagination"></div>
		</div>
		<div class="content">
			<div class="introduction" v-html="introduce">
				
			</div>
			<div class="button-single" @click="toSubmitActive">
				<span>我想发起活动</span>
			</div>
			<div class="video-wrap">
				<video controls :src="videoUrl" style="" >
					您的浏览器不支持 video 标签。
				</video>
			</div>
			<div class="activity-wrap">
				<Title title="正在进行的活动">
					<div class="title-more" @click="toActive" slot="title-more">
						<a href="javascript:;">更多</a>
						<i class="el-icon-arrow-right"></i>
					</div>
				</Title>
				<Activity :list="activityList"/>
			</div>
			<div class="partner-wrap" v-if="partnerList.length>0">
				<Title title="合作伙伴"></Title>
				<ul class="partner">
					<li v-for="item in partnerList"> 
						<a :href="item.officialUrl" target="_blank"><img :title="item.linkName" :src="item.picUrl"/></a>
					</li>
				</ul>
			</div>
			<div class="partner-wrap" v-if="linksList.length>0">
				<Title title="友情链接"></Title>
				<ul class="partner">
					<li v-for="item in linksList">
						<a :href="item.linkUrl" target="_blank"><img :title="item.linkName" :src="item.picUrl"/></a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.css'
	import Title from '@/components/title'
	import Activity from '@/components/activity'
	export default {
		name: 'Home',
		components: {
			Title,
			Activity
		},
		data(){
			return {
				bannerList: [],
				introduce: '',
				videoUrl: '',
				linksList: [],
				activityList: [],
				partnerList: []
			}
		},
		created(){
			this.getActivityList()
			this.getDataList()
		},
		methods: {
			toActive(){
				this.$router.push({
					path: '/activity'
				})
			},
			toSubmitActive(){
				this.$router.push({
					path: '/activitySubmit'
				})
			},
			//获取正在进行的活动
			async getActivityList(){
				let param = {
					limit: 50
				}
				ajaxParam(param)
				const res = await post('v1/vacation/getTopHoldVacationList', qs.stringify(param))
				if(res.data.code==200){
					this.activityList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取首页数据
			async getDataList(){
				let param = {}
				ajaxParam(param)
				const res = await post('website/index/homeData', qs.stringify(param))
				if(res.data.code==200){
					let entity = res.data.entity
					this.bannerList = entity.bannerList
					this.introduce = entity.introduce
					this.videoUrl = entity.videoUrl
					this.partnerList = entity.partnerList
					this.linksList = entity.linksList
					setTimeout(()=>{
						this.initSwiper()
					},300)
				} else {
					this.$message.error(res.data.msg)
				}
			},
			initSwiper(){
				new Swiper(".banner", {
					autoplay: 6000,
					autoplayDisableOnInteraction : false,
					// 轮播效果,默认为平滑轮播
					effect: "slide",
					pagination: '.swiper-pagination',
					paginationClickable :true
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.container{
		position: relative;
	}
	.banner{
		height:  366px;
		margin: 0 auto;
		img{
			width:100%;
			height: 100%;
		}
	}
	.introduction{
		padding-bottom: 15px;
	}
	.video-wrap{
		display: flex;
		justify-content: center;
		width: 100%;
		position: relative;
		padding-top: 15px;
		video {
			max-width: 100%;
		}
	}
	.partner{
		display: flex;
		flex-wrap: wrap;
		li{
			img{
				height: 52px;
				margin: 20px 25px 0 25px;
			}
		}
	}
</style>
